/*
 * tps-cilt-analizi — PulpoAR skinai-engine iframe köprüsü (eski tema Alpine `ciltAnalizi` bileşeninin karşılığı).
 * iframe → window.postMessage:
 *   { event_id: 'add_to_cart', data: <variantId> }       → sepete 1 adet ekle, cart:refresh, "sepete eklendi" penceresi
 *   { event_id: 'skin_problem_evaluation', ... }          → kupon penceresi (data-coupon-enabled="true" ise)
 * Yalnız data-origin'den gelen mesajlar işlenir. Pencere yerel <dialog> (odak tuzağı + Esc tarayıcıdan).
 */
(() => {
  if (customElements.get('tps-cilt-analizi')) return;

  const FADE_MS = 300;
  const COPIED_MS = 5000;
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class TpsCiltAnalizi extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-tps-ca-dialog]');
      this.copyButton = this.querySelector('[data-tps-ca-copy]');
      this.status = this.querySelector('[data-tps-ca-status]');
      this.onMessage = this.onMessage.bind(this);
      this.onDialogClick = this.onDialogClick.bind(this);
      this.onCancel = this.onCancel.bind(this);
      this.onCopy = this.onCopy.bind(this);
      this.onCloseClick = () => this.close();

      window.addEventListener('message', this.onMessage);
      if (!this.dialog) return;
      this.dialog.addEventListener('click', this.onDialogClick);
      this.dialog.addEventListener('cancel', this.onCancel);
      this.dialog.querySelectorAll('[data-tps-ca-close]').forEach((el) => el.addEventListener('click', this.onCloseClick));
      if (this.copyButton) this.copyButton.addEventListener('click', this.onCopy);
    }

    disconnectedCallback() {
      window.removeEventListener('message', this.onMessage);
      clearTimeout(this.copiedTimer);
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.unlockScroll();
    }

    onMessage(event) {
      if (event.origin !== this.dataset.origin) return;
      const payload = event.data;
      if (!payload || typeof payload !== 'object') return;

      if (payload.event_id === 'add_to_cart') {
        this.addToCart(payload.data);
      } else if (payload.event_id === 'skin_problem_evaluation') {
        if (this.dataset.couponEnabled === 'true') this.open('coupon');
      }
    }

    addToCart(variantId) {
      const id = Number(variantId);
      if (!Number.isInteger(id) || id <= 0) return;
      const routes = (window.theme && window.theme.routes) || {};
      const url = `${routes.cart_add_url || '/cart/add'}.js`;

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      })
        .then((response) => {
          if (!response.ok) throw new Error(`cart/add ${response.status}`);
          return response.json();
        })
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          this.open('cart');
        })
        .catch(() => {});
    }

    open(type) {
      if (!this.dialog) return;
      this.dialog.querySelectorAll('[data-tps-ca-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.tpsCaPanel !== type;
      });
      const message = this.dialog.querySelector(`[data-tps-ca-message="${type}"]`);
      if (message && message.id) this.dialog.setAttribute('aria-labelledby', message.id);
      this.resetCopy();

      clearTimeout(this.fadeTimer);
      if (!this.dialog.open) {
        this.lockScroll();
        this.dialog.showModal();
      }
      requestAnimationFrame(() => this.dialog.classList.add('is-visible'));
    }

    close() {
      if (!this.dialog || !this.dialog.open) return;
      this.dialog.classList.remove('is-visible');
      clearTimeout(this.fadeTimer);
      const finish = () => {
        if (this.dialog.open) this.dialog.close();
        this.unlockScroll();
      };
      if (reduceMotion()) finish();
      else this.fadeTimer = setTimeout(finish, FADE_MS);
    }

    onCancel(event) {
      // Esc: yerel kapanma yerine soluklaşarak kapan
      event.preventDefault();
      this.close();
    }

    onDialogClick(event) {
      // Kartın dışına (backdrop) tıklama — <dialog> öğesinin kendisine düşer
      if (event.target === this.dialog) this.close();
    }

    onCopy() {
      const code = this.dataset.couponCode || '';
      const done = () => {
        this.copyButton.classList.add('is-copied');
        this.copyButton.textContent = this.dataset.copiedLabel;
        if (this.status) this.status.textContent = this.dataset.copiedLabel;
        clearTimeout(this.copiedTimer);
        this.copiedTimer = setTimeout(() => this.resetCopy(), COPIED_MS);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(() => {});
      }
    }

    resetCopy() {
      clearTimeout(this.copiedTimer);
      if (!this.copyButton) return;
      this.copyButton.classList.remove('is-copied');
      this.copyButton.textContent = this.dataset.copyLabel;
      if (this.status) this.status.textContent = '';
    }

    lockScroll() {
      if (typeof window.setScrollbarWidth === 'function') window.setScrollbarWidth();
      document.body.classList.add('overflow-hidden');
    }

    unlockScroll() {
      document.body.classList.remove('overflow-hidden');
    }
  }

  customElements.define('tps-cilt-analizi', TpsCiltAnalizi);
})();
